import api from '../apis/UserApi';
import * as constant from "../constants/RefferalConstamt"

export const AddUserSchedule = (data,onSuccess,onError) => dispatch => {
  api.User().addUserschedule(data)
      .then(res => {
          console.log(res)
          localStorage.setItem("SCHEDULE",JSON.stringify(true))
          onSuccess()
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const MagicLogin = (data,onSuccess,onError) => {
  api.User().magicLogin(data)
      .then(res => {
          console.log(res)
          // localStorage.setItem("SCHEDULE",JSON.stringify(true))
          onSuccess(res)
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const UpdateUserSchedule = (data,onSuccess,onError) => dispatch => {
  api.User().updateUserschedule(data)
      .then(res => {
          console.log(res)
          onSuccess()
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const getUserCurrentSchedule = (data,onSuccess) => dispatch => {
  api.User().userCurrentschedule(data)
      .then(res => {
          console.log(res.data.userSchedule)
          onSuccess(res.data.userSchedule[0])
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);

        }
        })
}

export const updateUserPassword = (data,onSuccess,onError) => dispatch => {
  console.log(data)
  api.User().updateLearnerPassword(data)
      .then(res => {
          console.log(res.data)
          onSuccess()
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const emailNotification = (data,onSuccess,onError) => dispatch => {
  console.log(data)
  api.User().emailNotification(data)
      .then(res => {
          console.log(res.data)
          onSuccess(res)
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const emailUnsubscribe = (onSuccess,onError) => dispatch => {
  // console.log(data)
  api.User().emailUnsubscribe()
      .then(res => {
          console.log(res.data)
          onSuccess()
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const updateUserProfile = (data,onSuccess,onError) => dispatch => {
  console.log(data)
  api.User().updateLearnerProfile(data)
      .then(res => {
          console.log(res.data)
          onSuccess()
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}


export const GetRefferalData = (data) => dispatch => {
console.log(data)
  api.User().getRefferalData(data)
      .then(res => {
        dispatch({
          type:constant.GET_REFFERAL_DATA,
          payload:res.data
        })
          //console.log(res.data)
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);

        }
        })
}

export const LearnerWalletHistory = (data) => dispatch => {
console.log(data)
  api.User().learnerWalletHistory(data)
      .then(res => {
        dispatch({
          type:constant.GET_WALLET_HISTORY,
          payload:res.data.transactions
        })
          console.log(res.data.transactions)
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);

        }
        })
}


//TEACHER

export const AddTeacherSchedule = (data,onSuccess,onError) => dispatch => {
  api.User().addTeacherchedule(data)
      .then(res => {
          console.log(res)
          onSuccess()
      })
      .catch(err => {
        onError(err.response.data.message)
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);

        }
        })
}
export const TeacherCurrentSchedule = (data,onSuccess) => dispatch => {
  console.log(data._id)
  api.User().TeacherCurrentchedule(data)
      .then(res => {
          console.log(res)
          onSuccess(res.data.teacherSchedule[0])
          localStorage.setItem("WorkingHours",JSON.stringify(true))
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);

        }
        })
}

export const GetTeacherNotes = (onSuccess) => dispatch => {
  api.User().getTeacherNotes()
      .then(res => {
          console.log(res)
          onSuccess(res.data)
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);

        }
        })
}

export const GetTeacherNotesbyCount = (data,onSuccess,onError) => dispatch => {
  api.User().findteacherNoteByCount(data)
      .then(res => {
          console.log(res)
          onSuccess(res.data.note?res.data.note.noteLink:null)
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const WordOfTheDay = (onSuccess) => dispatch => {
  api.User().word()
      .then(res => {
          console.log(res)
          onSuccess(res.data)
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);

        }
        })
}

export const GetVideo = (onSuccess) => dispatch => {
  api.User().getVideo()
      .then(res => {
          console.log(res)
          // onSuccess(res.data)
          dispatch({
            type: constant.GET_ViDEOS,
            payload: res.data
        })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err);
        }
        })
}

//CONFIRM DEMO PAYMENT 

export const ConfirmDemoPayment = (data, onSuccess, onError,token) => (dispatch) => {
  // console.log(data)
  api.User()
    .confirmDemoPayment(data,token)
    .then((res) => {
       onSuccess();
    })
    .catch((err) => {
      console.log(err.response);
      onError(err.response.data.message);
    });
};

//SUBSCRIBE USER
export const SubscribeUser = (data, onSuccess, onError,token) => (dispatch) => {
  // console.log(data)
  api.User()
    .subscribe(data,token)
    .then((res) => {
       onSuccess(res);
    })
    .catch((err) => {
      console.log(err.response);
      onError(err.response.data.message);
    });
};

//UPGRADE USER PLAN
export const UpgradePlan = (data, onSuccess, onError) => (dispatch) => {
  // console.log(data)
  api.User()
    .upgrade(data)
    .then((res) => {
       onSuccess();
    })
    .catch((err) => {
      console.log(err.response);
      onError(err.response.data.message);
    });
};